(function () {
/**
 * Note the code in this file was cobbled together from the
 * original old version of the site (from around 2010) and
 * converted to Typescript without any major refactoring.
 */ function $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $14c571840e589f0e$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $1968e3edfc5cfc11$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $4fa1715f971c561b$var$extendStatics = function extendStatics1(d, b) {
    $4fa1715f971c561b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4fa1715f971c561b$var$extendStatics(d, b);
};
function $4fa1715f971c561b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4fa1715f971c561b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4fa1715f971c561b$export$18ce0697a983be9b = function __assign1() {
    $4fa1715f971c561b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4fa1715f971c561b$export$18ce0697a983be9b.apply(this, arguments);
};
function $4fa1715f971c561b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4fa1715f971c561b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4fa1715f971c561b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4fa1715f971c561b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4fa1715f971c561b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4fa1715f971c561b$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $4fa1715f971c561b$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4fa1715f971c561b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4fa1715f971c561b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4fa1715f971c561b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4fa1715f971c561b$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4fa1715f971c561b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4fa1715f971c561b$export$45d3717a4c69092e(o, m, p);
}
function $4fa1715f971c561b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4fa1715f971c561b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4fa1715f971c561b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4fa1715f971c561b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4fa1715f971c561b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4fa1715f971c561b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4fa1715f971c561b$export$10c90e4f7922046c(v) {
    return this instanceof $4fa1715f971c561b$export$10c90e4f7922046c ? (this.v = v, this) : new $4fa1715f971c561b$export$10c90e4f7922046c(v);
}
function $4fa1715f971c561b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4fa1715f971c561b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4fa1715f971c561b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4fa1715f971c561b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4fa1715f971c561b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4fa1715f971c561b$export$19a8beecd37a4c45 === "function" ? $4fa1715f971c561b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4fa1715f971c561b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4fa1715f971c561b$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $4fa1715f971c561b$var$ownKeys = function ownKeys1(o) {
    $4fa1715f971c561b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $4fa1715f971c561b$var$ownKeys(o);
};
function $4fa1715f971c561b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $4fa1715f971c561b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $4fa1715f971c561b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $4fa1715f971c561b$var$__setModuleDefault(result, mod);
    return result;
}
function $4fa1715f971c561b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4fa1715f971c561b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4fa1715f971c561b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4fa1715f971c561b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4fa1715f971c561b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4fa1715f971c561b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4fa1715f971c561b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4fa1715f971c561b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $4fa1715f971c561b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $4fa1715f971c561b$export$2e2bcd8739ae039 = {
    __extends: $4fa1715f971c561b$export$a8ba968b8961cb8a,
    __assign: $4fa1715f971c561b$export$18ce0697a983be9b,
    __rest: $4fa1715f971c561b$export$3c9a16f847548506,
    __decorate: $4fa1715f971c561b$export$29e00dfd3077644b,
    __param: $4fa1715f971c561b$export$d5ad3fd78186038f,
    __esDecorate: $4fa1715f971c561b$export$3a84e1ae4e97e9b0,
    __runInitializers: $4fa1715f971c561b$export$d831c04e792af3d,
    __propKey: $4fa1715f971c561b$export$6a2a36740a146cb8,
    __setFunctionName: $4fa1715f971c561b$export$d1a06452d3489bc7,
    __metadata: $4fa1715f971c561b$export$f1db080c865becb9,
    __awaiter: $4fa1715f971c561b$export$1050f835b63b671e,
    __generator: $4fa1715f971c561b$export$67ebef60e6f28a6,
    __createBinding: $4fa1715f971c561b$export$45d3717a4c69092e,
    __exportStar: $4fa1715f971c561b$export$f33643c0debef087,
    __values: $4fa1715f971c561b$export$19a8beecd37a4c45,
    __read: $4fa1715f971c561b$export$8d051b38c9118094,
    __spread: $4fa1715f971c561b$export$afc72e2116322959,
    __spreadArrays: $4fa1715f971c561b$export$6388937ca91ccae8,
    __spreadArray: $4fa1715f971c561b$export$1216008129fb82ed,
    __await: $4fa1715f971c561b$export$10c90e4f7922046c,
    __asyncGenerator: $4fa1715f971c561b$export$e427f37a30a4de9b,
    __asyncDelegator: $4fa1715f971c561b$export$bbd80228419bb833,
    __asyncValues: $4fa1715f971c561b$export$e3b29a3d6162315f,
    __makeTemplateObject: $4fa1715f971c561b$export$4fb47efe1390b86f,
    __importStar: $4fa1715f971c561b$export$c21735bcef00d192,
    __importDefault: $4fa1715f971c561b$export$da59b14a69baef04,
    __classPrivateFieldGet: $4fa1715f971c561b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4fa1715f971c561b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4fa1715f971c561b$export$81fdc39f203e4e04,
    __addDisposableResource: $4fa1715f971c561b$export$88ac25d8e944e405,
    __disposeResources: $4fa1715f971c561b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $4fa1715f971c561b$export$889dfb5d17574b0b
};


function $bcce38db0d2b4516$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $53f3ce6e74f6aaad$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $53f3ce6e74f6aaad$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



function $7b161889ca248e24$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $f8a29d58f287cd3d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $7b161889ca248e24$export$71511d61b312f219)(arr);
}


function $b0c62864eda90b51$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $cf17359bdd687909$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d6f91c356a8197fd$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7b161889ca248e24$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7b161889ca248e24$export$71511d61b312f219)(o, minLen);
}


function $4c858c0d999a5b9b$export$71511d61b312f219(arr) {
    return (0, $f8a29d58f287cd3d$export$71511d61b312f219)(arr) || (0, $b0c62864eda90b51$export$71511d61b312f219)(arr) || (0, $d6f91c356a8197fd$export$71511d61b312f219)(arr) || (0, $cf17359bdd687909$export$71511d61b312f219)();
}


var $4a35b05c93511915$export$2e2bcd8739ae039 = function EventEmitter() {
    "use strict";
    var _this = this;
    var _this1 = this;
    (0, $bcce38db0d2b4516$export$71511d61b312f219)(this, EventEmitter);
    this.listeners = {};
    this.on = function(event, listener) {
        var _this_listeners_event;
        _this.listeners[event] = (0, $4c858c0d999a5b9b$export$71511d61b312f219)((_this_listeners_event = _this.listeners[event]) !== null && _this_listeners_event !== void 0 ? _this_listeners_event : []).concat([
            listener
        ]);
        return {
            dispose: function() {
                _this.off(event, listener);
            }
        };
    };
    this.off = function(event, listener) {
        var _this_listeners_event, _this_listeners_event1;
        var _this_listeners_event_indexOf;
        var callbackIndex = (_this_listeners_event_indexOf = (_this_listeners_event = _this.listeners[event]) === null || _this_listeners_event === void 0 ? void 0 : _this_listeners_event.indexOf(listener)) !== null && _this_listeners_event_indexOf !== void 0 ? _this_listeners_event_indexOf : -1;
        if (callbackIndex > -1) (_this_listeners_event1 = _this.listeners[event]) === null || _this_listeners_event1 === void 0 ? void 0 : _this_listeners_event1.splice(callbackIndex, 1);
    };
    this.emit = function(event) {
        for(var _len = arguments.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            payload[_key - 1] = arguments[_key];
        }
        var _this_listeners_event;
        return (_this_listeners_event = _this1.listeners[event]) === null || _this_listeners_event === void 0 ? void 0 : _this_listeners_event.forEach(function(listener) {
            return listener(payload[0]);
        });
    };
};


var $a8880305110bc4a7$var$getIdFromYoutubeUrl = function(url) {
    var _url_match;
    var re = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
    return (_url_match = url.match(re)) === null || _url_match === void 0 ? void 0 : _url_match[7];
};
var $a8880305110bc4a7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Player() {
        var _this = this;
        (0, $bcce38db0d2b4516$export$71511d61b312f219)(this, Player);
        this.playheadInterval = 0;
        this.endSeconds = null;
        this.playerReady = false;
        this.ytPlayer = null;
        ///////////////////////////////
        //           EVENTS
        ///////////////////////////////
        this.onPlayerError = function(event) {
            _this.emitter.emit('error', {
                event: event
            });
        };
        this.onPlayerReady = function(event) {
            console.log('Player is ready');
            _this.playerReady = true;
            _this.ytPlayer = event.target;
            _this.emitter.emit('ready', {
                event: event
            });
        };
        this.onPlayerStateChange = function(event) {
            switch(event.data){
                case YT.PlayerState.PLAYING:
                    console.log("Player state change: playing");
                    _this.startPlayhead();
                    _this.emitter.emit('playing', {
                        event: event
                    });
                    break;
                case YT.PlayerState.ENDED:
                    console.log("Player state change: ended");
                    _this.stopPlayhead();
                    _this.emitter.emit('ended', {
                        event: event
                    });
                    break;
                case YT.PlayerState.PAUSED:
                    console.log("Player state change: paused");
                    _this.stopPlayhead();
                    _this.emitter.emit('paused', {
                        event: event
                    });
                    break;
                case YT.PlayerState.BUFFERING:
                    console.log("Player state change: buffering");
                    _this.stopPlayhead();
                    _this.emitter.emit('buffering', {
                        event: event
                    });
                    break;
                case YT.PlayerState.CUED:
                    console.log("Player state change: cued");
                    _this.emitter.emit('cued', {
                        event: event
                    });
                    break;
                case YT.PlayerState.UNSTARTED:
                    console.log("Player state change: unstarted");
                default:
                    break;
            }
        };
        this.emitter = new (0, $4a35b05c93511915$export$2e2bcd8739ae039)();
        this.on = this.emitter.on;
        this.off = this.emitter.off;
    }
    (0, $53f3ce6e74f6aaad$export$71511d61b312f219)(Player, [
        {
            ///////////////////////////////
            //          PLAYHEAD
            ///////////////////////////////
            key: "startPlayhead",
            value: function startPlayhead() {
                this.playheadInterval = setInterval(this.updatePlayhead, 100);
            }
        },
        {
            key: "stopPlayhead",
            value: function stopPlayhead() {
                clearInterval(this.playheadInterval);
            }
        },
        {
            key: "updatePlayhead",
            value: function updatePlayhead() {
                var _this_ytPlayer;
                if (typeof ((_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.getCurrentTime()) == 'undefined') {
                    clearInterval(this.playheadInterval);
                    return;
                }
                var playerCurrentTime = this.ytPlayer.getCurrentTime();
                if (this.endSeconds !== null && playerCurrentTime >= this.endSeconds) {
                    this.endSeconds = null;
                    this.stop();
                }
            }
        },
        {
            key: "seekToPercent",
            value: function seekToPercent(percent) {
                var _this_ytPlayer, _this_ytPlayer1;
                var _this_ytPlayer_getDuration;
                var time = percent * ((_this_ytPlayer_getDuration = (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.getDuration()) !== null && _this_ytPlayer_getDuration !== void 0 ? _this_ytPlayer_getDuration : 0);
                (_this_ytPlayer1 = this.ytPlayer) === null || _this_ytPlayer1 === void 0 ? void 0 : _this_ytPlayer1.seekTo(time, true);
            }
        },
        {
            ///////////////////////////////
            //       CORE FUNCTIONS
            ///////////////////////////////
            key: "isReady",
            value: function isReady() {
                return this.playerReady;
            }
        },
        {
            key: "play",
            value: function play() {
                var _this = this;
                var reset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var _this_ytPlayer, _this_ytPlayer1;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.play(reset);
                    });
                    return;
                }
                if (reset) (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.seekTo(0, true);
                (_this_ytPlayer1 = this.ytPlayer) === null || _this_ytPlayer1 === void 0 ? void 0 : _this_ytPlayer1.playVideo();
            }
        },
        {
            key: "stop",
            value: function stop1() {
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        stop();
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.stopVideo();
            }
        },
        {
            key: "pause",
            value: function pause() {
                var _this = this;
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.pause();
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.pauseVideo();
            }
        },
        {
            key: "unPause",
            value: function unPause() {
                var _this = this;
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.unPause();
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.playVideo();
            }
        },
        {
            key: "togglePause",
            value: function togglePause() {
                var _this_ytPlayer, _this_ytPlayer1;
                if (!this.isReady()) return;
                if (this.isPaused()) (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.playVideo();
                else (_this_ytPlayer1 = this.ytPlayer) === null || _this_ytPlayer1 === void 0 ? void 0 : _this_ytPlayer1.pauseVideo();
            }
        },
        {
            key: "isPaused",
            value: function isPaused() {
                if (!this.isReady()) return false;
                return this.getState() == YT.PlayerState.PAUSED;
            }
        },
        {
            key: "isPlaying",
            value: function isPlaying() {
                if (!this.isReady()) return false;
                return this.getState() == YT.PlayerState.PLAYING;
            }
        },
        {
            key: "getState",
            value: function getState() {
                var _this_ytPlayer;
                var _this_ytPlayer_getPlayerState;
                return (_this_ytPlayer_getPlayerState = (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.getPlayerState()) !== null && _this_ytPlayer_getPlayerState !== void 0 ? _this_ytPlayer_getPlayerState : YT.PlayerState.UNSTARTED;
            }
        },
        {
            key: "cueVideoById",
            value: function cueVideoById(videoId, startSeconds, suggestedQuality) {
                var _this = this;
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.cueVideoById(videoId, startSeconds, suggestedQuality);
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.cueVideoById(videoId, startSeconds, suggestedQuality);
            }
        },
        {
            key: "cueVideoByUrl",
            value: function cueVideoByUrl(videoUrl, startSeconds, suggestedQuality) {
                var id = $a8880305110bc4a7$var$getIdFromYoutubeUrl(videoUrl);
                if (!id) throw new Error('Failed to extract ID for videoUrl ' + videoUrl);
                this.cueVideoById(id, startSeconds, suggestedQuality);
            }
        },
        {
            key: "loadVideoById",
            value: function loadVideoById(videoId, startSeconds, suggestedQuality) {
                var _this = this;
                var _this_ytPlayer;
                console.log('loadVideoById', videoId, startSeconds, suggestedQuality);
                if (!this.isReady()) {
                    console.log('Player is not ready');
                    this.on("ready", function() {
                        console.log('After ready triggered', videoId);
                        _this.loadVideoById(videoId, startSeconds, suggestedQuality);
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.loadVideoById(videoId, startSeconds, suggestedQuality);
            }
        },
        {
            key: "loadVideoByUrl",
            value: function loadVideoByUrl(videoUrl, startSeconds, suggestedQuality) {
                var id = $a8880305110bc4a7$var$getIdFromYoutubeUrl(videoUrl);
                if (!id) throw new Error('Failed to extract ID for videoUrl ' + videoUrl);
                this.loadVideoById(id, startSeconds, suggestedQuality);
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                var _this_ytPlayer;
                var _this_ytPlayer_getCurrentTime;
                return (_this_ytPlayer_getCurrentTime = (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.getCurrentTime()) !== null && _this_ytPlayer_getCurrentTime !== void 0 ? _this_ytPlayer_getCurrentTime : 0;
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                var _this_ytPlayer;
                var _this_ytPlayer_getDuration;
                return (_this_ytPlayer_getDuration = (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.getDuration()) !== null && _this_ytPlayer_getDuration !== void 0 ? _this_ytPlayer_getDuration : 0;
            }
        },
        {
            key: "seekTo",
            value: function seekTo(seconds, allowSeekAhead) {
                var _this_ytPlayer;
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.seekTo(seconds, allowSeekAhead);
            }
        },
        {
            key: "clearVideo",
            value: function clearVideo() {
                var _this_ytPlayer;
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.stopVideo();
            }
        },
        {
            key: "mute",
            value: function mute() {
                var _this = this;
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.mute();
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.mute();
            }
        },
        {
            key: "unMute",
            value: function unMute() {
                var _this = this;
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.unMute();
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.unMute();
            }
        },
        {
            key: "isMuted",
            value: function isMuted() {
                var _this_ytPlayer;
                var _this_ytPlayer_isMuted;
                return (_this_ytPlayer_isMuted = (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.isMuted()) !== null && _this_ytPlayer_isMuted !== void 0 ? _this_ytPlayer_isMuted : false;
            }
        },
        {
            key: "toggleMute",
            value: function toggleMute() {
                if (this.isMuted()) this.unMute();
                else this.mute();
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                var _this = this;
                var _this_ytPlayer;
                if (!this.isReady()) {
                    this.on("ready", function() {
                        _this.setVolume(volume);
                    });
                    return;
                }
                (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.setVolume(volume);
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                var _this_ytPlayer;
                var _this_ytPlayer_getVolume;
                return (_this_ytPlayer_getVolume = (_this_ytPlayer = this.ytPlayer) === null || _this_ytPlayer === void 0 ? void 0 : _this_ytPlayer.getVolume()) !== null && _this_ytPlayer_getVolume !== void 0 ? _this_ytPlayer_getVolume : 100;
            }
        }
    ]);
    return Player;
}();




//const baseUrl = 'http://localhost:8787/api/data/' // Default local dev url of ../api project
var $06ca4b51228a00cc$var$baseUrl = 'https://api.ragereplay.com/api/data/' // Must have trailing slash
;
var $06ca4b51228a00cc$var$dataIndex = {
    playlists: []
};
var $06ca4b51228a00cc$export$c0933877973da308 = /*#__PURE__*/ function() {
    var _ref = (0, $14c571840e589f0e$export$71511d61b312f219)(function() {
        var response, data;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($06ca4b51228a00cc$var$dataIndex.playlists.length) return [
                        2,
                        Promise.resolve($06ca4b51228a00cc$var$dataIndex)
                    ];
                    return [
                        4,
                        fetch($06ca4b51228a00cc$var$baseUrl + 'index.json')
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new Error("Failed to load playlist index: ".concat(response.statusText));
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    $06ca4b51228a00cc$var$dataIndex = data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getPlaylistIndex() {
        return _ref.apply(this, arguments);
    };
}();
var $06ca4b51228a00cc$export$b9347112ad6b5fab = /*#__PURE__*/ function() {
    var _ref = (0, $14c571840e589f0e$export$71511d61b312f219)(function(path) {
        var response, data;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch($06ca4b51228a00cc$var$baseUrl + path)
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new Error("Failed to load playlist ".concat(path, ": ").concat(response.statusText));
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getPlaylist(path) {
        return _ref.apply(this, arguments);
    };
}();






//const baseUrl = 'http://localhost:8787/api/' // Default local dev url of ../api project
var $01cf4ed9cbd980a7$var$baseUrl = 'https://api.ragereplay.com/api/' // Must have trailing slash
;
var $01cf4ed9cbd980a7$export$bd80cdd36f597791 = function(artist, song) {
    return new Promise(function(resolve, reject) {
        $.ajax({
            method: 'GET',
            url: $01cf4ed9cbd980a7$var$baseUrl + 'musicvideosearch',
            dataType: 'json',
            data: {
                artist: artist,
                song: song
            },
            success: function(data) {
                return resolve(data);
            },
            error: function(_jqXHR, textStatus, errorThrown) {
                reject(textStatus + ': ' + errorThrown);
            }
        });
    });
};



var $d0c3271c451fac29$export$3748a2f1ceae9e24 = /*#__PURE__*/ function() {
    "use strict";
    function SourceList() {
        (0, $bcce38db0d2b4516$export$71511d61b312f219)(this, SourceList);
        this.pos = -1;
        this.sourcelist = [];
        this.emitter = new (0, $4a35b05c93511915$export$2e2bcd8739ae039)();
        this.on = this.emitter.on;
        this.off = this.emitter.off;
    }
    (0, $53f3ce6e74f6aaad$export$71511d61b312f219)(SourceList, [
        {
            key: "add",
            value: function add(videoInfo) {
                this.sourcelist.push(videoInfo);
            }
        },
        {
            key: "next",
            value: function next() {
                if (!this.hasNext()) return null;
                this.pos++;
                this.emitter.emit('change');
                return this.sourcelist[this.pos];
            }
        },
        {
            key: "prev",
            value: function prev() {
                if (!this.hasPrev()) return null;
                this.pos--;
                this.emitter.emit('change');
                return this.sourcelist[this.pos];
            }
        },
        {
            key: "hasNext",
            value: function hasNext() {
                return this.pos < this.sourcelist.length - 1;
            }
        },
        {
            key: "hasPrev",
            value: function hasPrev() {
                return this.pos > 0;
            }
        },
        {
            key: "seek",
            value: function seek(pos) {
                if (pos < 0 || pos > this.sourcelist.length) return;
                this.pos = pos;
                this.emitter.emit('change');
            }
        },
        {
            key: "indexOf",
            value: function indexOf(sourceListItem) {
                return this.sourcelist.indexOf(sourceListItem);
            }
        },
        {
            key: "current",
            value: function current() {
                if (this.pos < 0) return null;
                return this.sourcelist[this.pos];
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.pos = -1;
                this.sourcelist = [];
                this.emitter.emit('cleared');
            }
        },
        {
            //sets the current source as invalid/error
            key: "setCurrentError",
            value: function setCurrentError() {
                if (this.pos < 0) return;
                this.sourcelist[this.pos].error = true;
            }
        },
        {
            key: "load",
            value: /**
   * Clears sources list and loads new sources from the API.
   * @param track PlaylistTrack
   */ function load(track) {
                var _this = this;
                return (0, $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var sources, e;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.clear();
                                _this.emitter.emit('loadBegin', {
                                    track: track
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, $01cf4ed9cbd980a7$export$bd80cdd36f597791)(track.artist, track.song)
                                ];
                            case 2:
                                sources = _state.sent();
                                sources.forEach(function(source) {
                                    var _source_title;
                                    _this.add({
                                        title: (_source_title = source.title) !== null && _source_title !== void 0 ? _source_title : 'Unknown title',
                                        url: source.url
                                    });
                                });
                                _this.pos = 0;
                                _this.emitter.emit('change');
                                _this.emitter.emit('loadSuccess', {
                                    track: track
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                _this.emitter.emit('loadError', {
                                    track: track,
                                    error: e.message
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SourceList;
}();





var $84d6f6cd7169a1ee$export$199631bfaacffce5 = /*#__PURE__*/ function(TrackChangeDirection) {
    TrackChangeDirection[TrackChangeDirection["FORWARD"] = 1] = "FORWARD";
    TrackChangeDirection[TrackChangeDirection["BACKWARD"] = -1] = "BACKWARD";
    TrackChangeDirection[TrackChangeDirection["NONE"] = 0] = "NONE";
    return TrackChangeDirection;
}({});
var $84d6f6cd7169a1ee$export$8931430458a8a419 = /*#__PURE__*/ function() {
    "use strict";
    function TrackList() {
        (0, $bcce38db0d2b4516$export$71511d61b312f219)(this, TrackList);
        this.max = 1000 // the playlist will never grow bigger than this
        ;
        this.pos = -1;
        this.playlist = [];
        this.emitter = new (0, $4a35b05c93511915$export$2e2bcd8739ae039)();
        this.on = this.emitter.on;
        this.off = this.emitter.off;
    }
    (0, $53f3ce6e74f6aaad$export$71511d61b312f219)(TrackList, [
        {
            // Adds track to end of the playlist
            // if the track param is an array then it will loop through and add each track
            key: "add",
            value: function add(track) {
                var _this = this;
                if (Array.isArray(track)) {
                    track.forEach(function(t) {
                        return _this.add(t);
                    });
                    return;
                }
                if (this.playlist.length >= this.max) {
                    this.playlist.shift() // remove first item from playlist
                    ;
                    if (this.pos >= 0) this.pos--;
                }
                this.playlist.push(track);
                this.emitter.emit('modified');
            }
        },
        {
            // Removes track from the playlist
            // returns the removed track or null
            key: "remove",
            value: function remove(track) {
                var index = this.playlist.indexOf(track);
                if (index != -1) {
                    var _$track = this.playlist.splice(index, 1);
                    if (this.pos > index && this.pos >= 0) this.pos--;
                    this.emitter.emit('modified');
                    return _$track[0];
                }
                return null;
            }
        },
        {
            // Returns the next track or null
            // updatePos: whether to automatically increment the playlist pos
            key: "next",
            value: function next() {
                var updatePos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                if (!this.hasNext()) {
                    this.emitter.emit('finished');
                    return null;
                }
                var result = this.playlist[this.pos + 1];
                if (updatePos == true) {
                    this.pos++;
                    this.emitter.emit('change', {
                        current: this.playlist[this.pos],
                        previous: this.playlist[this.pos - 1],
                        direction: 1
                    });
                }
                return result;
            }
        },
        {
            // Returns the prev track or null
            // updatePos: whether to automatically decrement the playlist pos
            key: "prev",
            value: function prev() {
                var updatePos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                if (!this.hasPrev()) return null;
                var result = this.playlist[this.pos - 1];
                if (updatePos == true) {
                    this.pos--;
                    this.emitter.emit('change', {
                        current: this.playlist[this.pos],
                        previous: this.playlist[this.pos + 1],
                        direction: -1
                    });
                }
                return result;
            }
        },
        {
            key: "hasNext",
            value: function hasNext() {
                return this.pos < this.playlist.length - 1;
            }
        },
        {
            key: "hasPrev",
            value: function hasPrev() {
                return this.pos > 0;
            }
        },
        {
            key: "current",
            value: function current() {
                if (this.pos < 0) return null;
                return this.playlist[this.pos];
            }
        },
        {
            key: "rewind",
            value: function rewind() {
                this.pos = 0;
                this.emitter.emit('change', {
                    current: this.playlist[this.pos],
                    previous: this.next(false),
                    direction: -1
                });
                return this.playlist[this.pos];
            }
        },
        {
            key: "fastForward",
            value: function fastForward() {
                this.pos = this.playlist.length - 1;
                this.emitter.emit('change', {
                    current: this.playlist[this.pos],
                    previous: this.prev(false),
                    direction: 1
                });
                return this.playlist[this.pos];
            }
        },
        {
            key: "skip",
            value: function skip(newPos) {
                if (typeof newPos == "undefined" || this.playlist[newPos] == undefined) {
                    console.log("Tracklist.skip() Position is not valid. Ignoring...");
                    return this.playlist[this.pos];
                }
                if (this.pos == newPos) return this.playlist[this.pos];
                var direction = 0;
                var secondaryTrack = null;
                if (newPos > this.pos) {
                    direction = 1;
                    secondaryTrack = this.next(false);
                } else {
                    direction = -1;
                    secondaryTrack = this.prev(false);
                }
                this.pos = newPos;
                this.emitter.emit('change', {
                    current: this.playlist[this.pos],
                    previous: secondaryTrack,
                    direction: direction
                });
                return this.playlist[this.pos];
            }
        },
        {
            // Returns the size of the playlist
            key: "length",
            value: function length() {
                return this.playlist.length;
            }
        },
        {
            key: "getPosition",
            value: function getPosition() {
                return this.pos;
            }
        },
        {
            // Returns how many tracks are yet to be played in the current playlist
            key: "upcomingLength",
            value: function upcomingLength() {
                return this.playlist.length - 1 - this.pos;
            }
        },
        {
            // Clears all the next tracks from the playlist
            key: "clearUpcoming",
            value: function clearUpcoming() {
                this.playlist = this.playlist.slice(0, this.pos + 1);
                this.emitter.emit('modified');
            }
        },
        {
            // Clear track history
            key: "clear",
            value: function clear() {
                this.playlist = [];
                this.pos = -1;
                this.emitter.emit('modified');
            }
        }
    ]);
    return TrackList;
}();


var $58f1aa7a409072fa$export$324699496a105db8 = function(rawStr) {
    return rawStr.replace(/[\u00A0-\u9999<>\&]/g, function(i) {
        return '&#' + i.charCodeAt(0) + ';';
    });
};
var $58f1aa7a409072fa$export$a1a11b095f88289a = $58f1aa7a409072fa$export$324699496a105db8;


var $f2827e7851f3fa53$var$formatSpecialTitle = function(title) {
    var toReplace = [
        'guest programs rage',
        'guest program rage',
        'guest programs',
        'guest program',
        'Guest Programs',
        'Grust Program'
    ];
    toReplace.forEach(function(str) {
        title = title.replace(str, '');
    });
    return title.charAt(0).toUpperCase() + title.substring(1, 30).trim();
};
function $f2827e7851f3fa53$export$2e2bcd8739ae039(_playlists) {
    var playlists = _playlists.slice().sort(function(a, b) {
        var _a_special, _b_special;
        return ((_a_special = a.special) !== null && _a_special !== void 0 ? _a_special : '').localeCompare((_b_special = b.special) !== null && _b_special !== void 0 ? _b_special : '');
    });
    var $el = $(document.createDocumentFragment());
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = playlists[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var playlist = _step.value;
            if (!playlist.special || playlist.special.startsWith('New Music')) continue;
            var id = playlist.path.replace('.json', '');
            $el.append('<p>\n        <a href="#/episode/'.concat((0, $58f1aa7a409072fa$export$a1a11b095f88289a)(id), '/1" class="playlist" data-playlist_id="').concat((0, $58f1aa7a409072fa$export$a1a11b095f88289a)(id), '">\n          ').concat((0, $58f1aa7a409072fa$export$a1a11b095f88289a)($f2827e7851f3fa53$var$formatSpecialTitle(playlist.special)), "\n        </a>\n      </p>"));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $el;
}


var $e2b3e6a926fe34e0$export$ed7e01d08fb37999 = function(number) {
    var selector;
    if (number <= 0) selector = 4;
    else if (number > 3 && number < 21 || number % 10 > 3) selector = 0;
    else selector = number % 10;
    return number + [
        'th',
        'st',
        'nd',
        'rd',
        ''
    ][selector];
};
var $e2b3e6a926fe34e0$export$2061056d06d7cdf7 = function(date) {
    var weekDays = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ];
    return weekDays[date.getDay()];
};
var $e2b3e6a926fe34e0$export$c1d85b1285963efe = function(date) {
    var day = $e2b3e6a926fe34e0$export$ed7e01d08fb37999(date.getDate());
    var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    return "".concat(day, " ").concat(monthNames[date.getMonth()]);
};



function $f0dd997f1b5daa2a$export$2e2bcd8739ae039(_playlists) {
    var playlists = _playlists.slice().reverse();
    var $el = $(document.createDocumentFragment());
    var prevYear = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = playlists[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var playlist = _step.value;
            var date = new Date(Date.parse(playlist.date));
            // @TODO - original code added one day to date if
            //         timeslot is morning, check if still required
            var year = date.getFullYear();
            if (prevYear != year) {
                $el.append('\n        <div class="clearfix"></div>\n        <a name="episode-'.concat(year, '"></a>\n        <h2><span>').concat(year, "</span></h2>"));
                prevYear = year;
            }
            var id = playlist.path.replace('.json', '');
            $el.append('<p>\n        <a href="#/episode/'.concat((0, $58f1aa7a409072fa$export$a1a11b095f88289a)(id), '/1"\n           class="playlist"\n           data-playlist_id="').concat((0, $58f1aa7a409072fa$export$a1a11b095f88289a)(id), '"\n           ').concat(playlist.special ? 'rel="tooltip" title="'.concat((0, $58f1aa7a409072fa$export$a1a11b095f88289a)(playlist.special), '" data-placement="top"') : '', '\n        >\n          <span style="color:#BBB; font-family:monospace;">').concat((0, $e2b3e6a926fe34e0$export$2061056d06d7cdf7)(date), "</span>\n          ").concat((0, $e2b3e6a926fe34e0$export$c1d85b1285963efe)(date), "\n          ").concat(playlist.special ? '<span class="label label-info">s</span>' : '', "\n        </a>\n      </p>"));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $el;
}


function $f3231d523fa2a92f$export$2e2bcd8739ae039() {
    var $el = $(document.createDocumentFragment());
    var startYear = 1999;
    var endYear = new Date().getFullYear();
    for(var year = startYear; year <= endYear; year++)$el.append('<li><a class="skip-to-year" data-year="'.concat(year, '" href="javascript:void(0)">').concat(year, "</a></li>"));
    return $el;
}


var $8359390af20d48a4$var$currentPlaylist = null;
var $8359390af20d48a4$var$trackList = new (0, $84d6f6cd7169a1ee$export$8931430458a8a419)();
var $8359390af20d48a4$var$sourceList = new (0, $d0c3271c451fac29$export$3748a2f1ceae9e24)();
var $8359390af20d48a4$var$player = new (0, $a8880305110bc4a7$export$2e2bcd8739ae039)();
window.onYouTubePlayerAPIReady = function() {
    new YT.Player('player', {
        height: '315',
        width: '560',
        videoId: 'ZzxKW6O8sNM',
        playerVars: {
            fs: 0,
            autoplay: 0,
            showinfo: 0,
            controls: 0,
            disablekb: 1,
            iv_load_policy: 3,
            modestbranding: 1,
            rel: 0,
            loop: 0
        },
        events: {
            onReady: $8359390af20d48a4$var$player.onPlayerReady,
            onStateChange: $8359390af20d48a4$var$player.onPlayerStateChange,
            onError: $8359390af20d48a4$var$player.onPlayerError
        }
    });
};
var $8359390af20d48a4$var$init = function() {
    // ROUTER
    var router = new Simrou({
        '/episode/top200': {
            get: function() {
                router.navigate("/episode/top200/1");
            }
        },
        '/episode/top200/:track': {
            get: function(_, param) {
                var track = param.track;
                $8359390af20d48a4$var$loadPlaylist('top200', function() {
                    $8359390af20d48a4$var$trackList.skip(track - 1);
                });
            }
        },
        '/episode/:year/:month/:day': {
            get: function(_, param) {
                var year = param.year, month = param.month, day = param.day;
                router.navigate("/episode/".concat(year, "/").concat(month, "/").concat(day, "/1"));
            }
        },
        '/episode/:year/:month/:day/:track': {
            get: function(_, param) {
                var year = param.year, month = param.month, day = param.day, track = param.track;
                $8359390af20d48a4$var$loadPlaylist("".concat(year, "/").concat(month, "/").concat(day), function() {
                    $8359390af20d48a4$var$trackList.skip(track - 1);
                });
            }
        },
        '/home': {
            get: function() {
                $8359390af20d48a4$var$player.play(true) //play intro video
                ;
            }
        }
    });
    window.onhashchange = function init() {
        router.navigate(window.location.hash);
    };
    // EPISODE/SPECIAL TAB
    $('body').on('click', '.nav .skip-to-year', function(_e) {
        var year = $(this).attr('data-year');
        var anchor = $('a[name=episode-' + year + ']');
        $('#pop-up-container').scrollTop(anchor.position().top);
    });
    $('.sort-by-date').on('click', function(_e) {
        $('#specials').hide();
        $('#episodes').show();
        $('.sort-by-date').parent().addClass('active');
        $('.sort-by-special').parent().removeClass('active');
        $('.skip-to-year-toggle').parent().removeClass('disabled');
    });
    $('.sort-by-special').on('click', function(_e) {
        $('#specials').show();
        $('#episodes').hide();
        $('.sort-by-date').parent().removeClass('active');
        $('.sort-by-special').parent().addClass('active');
        $('.skip-to-year-toggle').parent().addClass('disabled');
    });
    // Load playlist data, then render episodes tabs
    (0, $06ca4b51228a00cc$export$c0933877973da308)().then(function(data) {
        $('#episodes').empty().append((0, $f0dd997f1b5daa2a$export$2e2bcd8739ae039)(data.playlists));
        $('#specials').empty().append((0, $f2827e7851f3fa53$export$2e2bcd8739ae039)(data.playlists));
        $('#year-dropdown .dropdown-menu').append((0, $f3231d523fa2a92f$export$2e2bcd8739ae039)());
        $('[data-playlist-count]').text(data.playlists.length);
        $8359390af20d48a4$var$initTooltips();
    });
    // TOP MENU
    $('.episode-button').on('click', function(_e) {
        $8359390af20d48a4$var$changeTab('episodeList');
    });
    $('.now-playing-button').on('click', function(_e) {
        $8359390af20d48a4$var$changeTab('nowPlaying');
    });
    $('.player-backward').on('click', function(_e) {
        //trackList.prev()
        if ($8359390af20d48a4$var$trackList.hasPrev()) router.navigate('/episode/' + $8359390af20d48a4$var$currentPlaylist + '/' + $8359390af20d48a4$var$trackList.getPosition());
    });
    $('.player-forward').on('click', function(_e) {
        if ($8359390af20d48a4$var$trackList.hasNext()) router.navigate('/episode/' + $8359390af20d48a4$var$currentPlaylist + '/' + ($8359390af20d48a4$var$trackList.getPosition() + 2));
    });
    $('.player-pause').on('click', function(_e) {
        $8359390af20d48a4$var$player.togglePause();
    });
    if (!document.fullscreenEnabled) $('.player-fullscreen').hide();
    else $('.player-fullscreen').on('click', function(_e) {
        if (document.fullscreenElement) document.exitFullscreen();
        else document.documentElement.requestFullscreen({
            navigationUI: 'hide'
        });
    });
    ///// EVENTS /////
    $8359390af20d48a4$var$trackList.on('change', $8359390af20d48a4$var$onTrackChange);
    $8359390af20d48a4$var$trackList.on('finished', function() {
        return $8359390af20d48a4$var$changeTab('episodeList');
    });
    $8359390af20d48a4$var$sourceList.on('change', $8359390af20d48a4$var$onSourceChange);
    $8359390af20d48a4$var$sourceList.on('loadError', $8359390af20d48a4$var$onSourceListLoadFailed);
    $8359390af20d48a4$var$player.on('error', function(error) {
        var _sourceList_current;
        console.log('Failed to load video', (_sourceList_current = $8359390af20d48a4$var$sourceList.current()) === null || _sourceList_current === void 0 ? void 0 : _sourceList_current.url, error);
        $8359390af20d48a4$var$sourceList.setCurrentError();
        var result = $8359390af20d48a4$var$sourceList.next() // load next alt sources, until we have tried them all
        ;
        if (result === null) $8359390af20d48a4$var$trackList.next();
    });
    $8359390af20d48a4$var$player.on("ended", function() {
        return $8359390af20d48a4$var$trackList.next();
    });
    $8359390af20d48a4$var$player.on("paused", function() {
        $('.player-pause i').removeClass().addClass('icon-play');
    });
    $8359390af20d48a4$var$player.on("playing", function() {
        $('.player-pause i').removeClass().addClass('icon-pause');
    });
    ///// KEYBOARD SHORTCUTS /////
    $(document).on('keyup', function(e) {
        var key = e.which;
        //Left arrow
        if (key == 37) $8359390af20d48a4$var$trackList.prev();
        //Right arrow
        if (key == 39) $8359390af20d48a4$var$trackList.next();
        //Space bar
        if (key == 32) $8359390af20d48a4$var$player.togglePause();
        return true;
    });
    // Prevent default (i.e. scrolling) for the left and right arrow keys
    $(document).on('keydown', function(e) {
        var key = e.which;
        if (key == 37 || key == 39) {
            e.preventDefault();
            return false;
        }
        return true;
    });
    router.start('/home');
};
var $8359390af20d48a4$var$loadPlaylist = /*#__PURE__*/ function() {
    var _ref = (0, $14c571840e589f0e$export$71511d61b312f219)(function(id, callback) {
        var path, data, error;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof id == 'undefined') throw "RageAgain.loadPlaylist() id is undefined.";
                    path = id + '.json';
                    if ($8359390af20d48a4$var$currentPlaylist == id) {
                        if (typeof callback === 'function') callback($8359390af20d48a4$var$currentPlaylist);
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $06ca4b51228a00cc$export$b9347112ad6b5fab)(path)
                    ];
                case 2:
                    data = _state.sent();
                    $('#fullscreen-loader').hide();
                    if (!data || !data.tracks) {
                        alert('Failed to load selected playlist. No tracks found.');
                        return [
                            2
                        ];
                    }
                    $8359390af20d48a4$var$currentPlaylist = id;
                    $8359390af20d48a4$var$trackList.clear();
                    $8359390af20d48a4$var$trackList.add(data.tracks);
                    if (typeof callback === 'function') callback($8359390af20d48a4$var$currentPlaylist);
                    $('a span.now-playing-label').remove();
                    $('a[data-playlist_id="' + id + '"]').append('<span class="label label-important now-playing-label">p</span>');
                    $8359390af20d48a4$var$changeTab('nowPlaying');
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error('Failed to load playlist', error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function loadPlaylist(id, callback) {
        return _ref.apply(this, arguments);
    };
}();
var $8359390af20d48a4$var$initTooltips = function() {
    $(document).tooltip({
        selector: 'a[rel=tooltip]',
        placement: function placement(_tooltip, target) {
            return $(target).attr('data-placement') || 'top';
        },
        trigger: 'manual'
    });
    var checkTooltipOffset = function() {
        var _$_children_offset;
        var leftOffset = (_$_children_offset = $('body').children('.tooltip').offset()) === null || _$_children_offset === void 0 ? void 0 : _$_children_offset.left;
        if ((leftOffset !== null && leftOffset !== void 0 ? leftOffset : 0) < 0) $('body').children('.tooltip').offset({
            left: 0
        });
    };
    $('a[rel=tooltip]').on('mouseenter', function(e) {
        $(this).tooltip('show');
        checkTooltipOffset();
        setTimeout(checkTooltipOffset, 100);
        e.preventDefault();
        e.stopImmediatePropagation();
    });
    $('a[rel=tooltip]').on('mouseleave', function(_e) {
        $(this).tooltip('hide');
    });
};
var $8359390af20d48a4$var$onTrackChange = function onTrackChange(param) {
    var curTrack = param.current;
    $8359390af20d48a4$var$sourceList.load(curTrack);
    $('#nav-right').fadeIn();
    $('.artist').text(curTrack.artist);
    $('.track').text(curTrack.song);
    document.title = "".concat(curTrack.song, " by ").concat(curTrack.artist, " | Rage Replay");
    if (curTrack.label) $('.tracklabel').text('(' + curTrack.label + ')');
    else $('.tracklabel').text('');
    $('#now-playing-info').hide().delay(1500).fadeIn('slow').delay(8000).fadeOut();
    if ($8359390af20d48a4$var$player.getState() == YT.PlayerState.UNSTARTED) $8359390af20d48a4$var$player.play();
};
var $8359390af20d48a4$var$onSourceListLoadFailed = function onSourceListLoadFailed() {
    console.log('onSourceListLoadFailed');
    var current = $8359390af20d48a4$var$trackList.current();
    // Remove this track and load next one
    // @TODO notify user that track failed to load
    if (current) {
        var _trackList_current, _trackList_current1;
        console.log("No sources available. Removing track...".concat((_trackList_current = $8359390af20d48a4$var$trackList.current()) === null || _trackList_current === void 0 ? void 0 : _trackList_current.song, " - ").concat((_trackList_current1 = $8359390af20d48a4$var$trackList.current()) === null || _trackList_current1 === void 0 ? void 0 : _trackList_current1.artist));
        $8359390af20d48a4$var$trackList.remove(current);
    }
    $8359390af20d48a4$var$trackList.next();
};
var $8359390af20d48a4$var$onSourceChange = function onSourceChange() {
    var _sourceList_current;
    console.log('onSourceChange');
    if ((_sourceList_current = $8359390af20d48a4$var$sourceList.current()) === null || _sourceList_current === void 0 ? void 0 : _sourceList_current.url) $8359390af20d48a4$var$player.loadVideoByUrl($8359390af20d48a4$var$sourceList.current().url);
};
var $8359390af20d48a4$var$changeTab = function changeTab(tabName) {
    if (tabName == 'episodeList') {
        $('header #nav-left a').removeClass('active');
        $('.episode-button').addClass('active');
        $('#overlay').fadeIn();
        $('#episode-container').show();
        $('#pop-up-container').show();
    } else if (tabName == 'nowPlaying') {
        $('header #nav-left a').removeClass('active');
        $('.now-playing-button').addClass('active');
        $('#overlay').fadeOut();
        $('#episode-container').hide();
        $('#pop-up-container').hide();
    }
};
function $8359390af20d48a4$export$2e2bcd8739ae039() {
    if (!!window.$ && !!window.Simrou) {
        $(function() {
            return $8359390af20d48a4$var$init();
        });
        return;
    }
    var timer = setInterval(function() {
        if (!!window.$ && !!window.Simrou) {
            clearInterval(timer);
            $(function() {
                return $8359390af20d48a4$var$init();
            });
        }
    }, 100);
}


(0, $8359390af20d48a4$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=index.fef4e4d2.js.map
